import Header from './components/Header';
import About from './components/About';
import Careers from './components/Careers';
import Services from './components/Services';
import MoreAbout from './components/MoreAbout';
import Rating from './components/Ratings';
import Barbers from './components/Barbers';
import Gallery from './components/Gallery';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App my-page-border">
     <Header />
     <About />
     <Careers />
     <Services />
     <MoreAbout />
     <Rating />
     <Barbers />
     <Gallery />
     <Footer />
    </div>
  );
}

export default App;
